import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { TimePeriods } from '@shared';

@Component({
  selector: 'mojo-job-salary-temporary-contract',
  templateUrl: './job-salary-temporary-contract.component.html',
  styleUrls: ['./job-salary-temporary-contract.component.scss'],
})
export class JobSalaryTemporaryContractFormComponent {
  @Input() form: UntypedFormGroup;
  @Input() set isSowTemplate(val: boolean) {
    this.isSow = val;
    this.currentTimePeriod = this.form.get('payRatePeriod').value;
  }
  @Output() timePeriodChange = new EventEmitter<TimePeriods>();
  isSow = false;
  timePeriods = TimePeriods;
  currentTimePeriod;

  onPayRateChange(option: MatRadioChange) {
    this.timePeriodChange.emit(option.value);
  }
}
